<template>
  <modal-dialog
    :visible="dialog"
    persistent
  >
    <v-container
      fluid
      class="d-flex align-center flex-column"
    >
      <canvas
        id="qr-canvas"
        :class="['qr-code-placeholder', {'compact': $vuetify.breakpoint.xsOnly}]"
      >&nbsp;</canvas>
      <p class="pt-1">
        {{ $t('label.description_widget_qr') }}
      </p>

      <div class="w-100">
        <v-divider class="pt-0 pb-4" />
        <v-textarea
          v-model="qrcodeDescription"
          rows="3"
          :label="$t('label.qrcode_custom_message')"
        />
      </div>
    </v-container>
    <template #actions>
      <v-btn
        text
        color="primary"
        @click="print"
      >
        <v-icon class="mr-2">
          mdi-printer
        </v-icon>
        <template v-if="$vuetify.breakpoint.smAndUp">
          {{ $t('button.print') }}
        </template>
      </v-btn>
      <v-btn
        text
        color="primary"
        @click="saveImage"
      >
        <v-icon class="mr-2">
          mdi-download
        </v-icon> {{ $t('button.save_as_image') }}
      </v-btn>
      <v-spacer />
      <v-btn
        text
        color="error"
        @click="$emit('close')"
      >
        {{ $t('button.close') }}
      </v-btn>
    </template>
  </modal-dialog>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import QrcodeWithLogos from 'qrcode-with-logos';
import DialogClosable from '@/mixins/dialog-closable';
import { hostedWidgetURL } from '@/services/configuration';

export default Vue.extend({
  name: 'WebsiteQrDialog',
  components: { },
  mixins: [DialogClosable],
  props: {
    hostedFormUrl: { type: String as PropType<string>, required: true },
  },
  data() {
    return {
      qrcode: null as any,
      qrcodeDescription: this.$i18n.t('label.qrcode_message_placeholder'),
    };
  },
  computed: {},
  watch: { },
  mounted() {
    setTimeout(this.createCode, 100);
  },
  methods: {
    createCode() {
      const logo = (import.meta.env.VITE_QRCODE_WITH_LOGO === 'true' ? { src: '/assets/qrcode-logo.svg' } : undefined);
      this.qrcode = new QrcodeWithLogos({
        canvas: document.getElementById('qr-canvas') as HTMLCanvasElement,
        content: this.hostedFormUrl,
        width: this.$vuetify.breakpoint.xsOnly ? 300 : 380,
        logo,
      });
    },
    print() {
      const dataUrl = (document.getElementById('qr-canvas') as HTMLCanvasElement).toDataURL();
      const newWin = window.open('', 'windowName', 'height=1024,width=682');
      newWin!.document.write(`
      <html>
      <body style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Helvetica, Arial, sans-serif"
            onload="window.print()">
        <center><img src="${dataUrl}"/></center>
        <h3 style="text-align: center">
          ${this.qrcodeDescription}
        </h3>
      </body>
      </html>`);
      newWin!.document.close();
      newWin!.focus();
    },
    saveImage() {
      const canvas = document.getElementById('qr-canvas') as HTMLCanvasElement | null;
      if (!canvas) return;
      const link = document.createElement('a');
      link.download = 'QRCode.png';
      link.href = canvas.toDataURL('image/png');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
});
</script>

<style scoped>

.qr-code-placeholder {
  width: 380px;
  height: 380px;
}
.qr-code-placeholder.compact {
  width: 300px;
  height: 300px;
}

</style>
